/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Card, FormControl, InputLabel, Checkbox, FormHelperText
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchNotFound from '../../../SearchNotFound';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';

var screenCode = "CATEGORYWISEQTYBOUGHTAGAINSTPURCHASEORDER"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [

    {
        id: 'productSubCategoryName',
        numeric: false,
        disablePadding: false,
        label: 'SKU Category',
        align: "left"
    },
    {
        id: 'orderedQty',
        numeric: true,
        disablePadding: false,
        label: 'Ordered Qty',
        align: "right"
    },
    {
        id: 'suppliedQty',
        numeric: true,
        disablePadding: false,
        label: 'Supplied Qty',
        align: "right"
    },
    {
        id: 'fillRate',
        numeric: true,
        disablePadding: false,
        label: 'Fill Rate',
        align: "right"
    },

];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function CategoryWiseQtyBoughtAgainstPurchaseOrder(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [productSubcatogery, setProductSubcatogery] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [priceNegotiation, setPriceNegotiation] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, priceNegotiation.length - page * rowsPerPage);

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        productSubCategoryID: 0,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const priceNegotiationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array()
            .min(1, 'Please select at least one fresh collection center')
            .required('Please select at least one fresh collection center'),
        productSubCategoryID: Yup.array()
            .min(1, 'Please select at least one product category')
            .required('Please select at least one product category'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select From Date').required('Start From Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        productSubCategoryID: '',
        toDate: '',
        fromDate: ''
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            productSubCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
        },
        validationSchema: priceNegotiationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    const [totalValues, setTotalValues] = useState({
        totalOrderedQty: 0,
        totalSuppliedQty: 0,
        totalFillRate: 0,
    });
    useEffect(() => {
        getPermissions();
    }, []);
 
    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCATEGORYWISEQTYBOUGHTAGAINSTPURCHASE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductSubCategoties());
    }

    async function SubmitForm() {
        let model = {
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            productSubCategoryID: selectedCategoryOptions.map(x => x).join(',').toString(),
            fromDate: fromDate,
            toDate: toDate
        }
        var response = await services.GetReportData(model);
        let res = _.cloneDeep(response);
        var result = [];
        res.forEach(x => {
            var duplicateDate = result.find(y => y.productSubCategoryName === x.productSubCategoryName);

            if (duplicateDate) {
                duplicateDate.productSubCategoryName = x.productSubCategoryName;
                duplicateDate.orderedQty = duplicateDate.orderedQty + x.orderedQty;
                duplicateDate.suppliedQty = duplicateDate.suppliedQty + x.suppliedQty;
            }
            else {
                result.push({
                    productSubCategoryName: x.productSubCategoryName,
                    orderedQty: x.orderedQty,
                    suppliedQty: x.suppliedQty,
                });
            }
        });
        result.forEach(x => {
            x.fillRate = x.suppliedQty == 0 ? 0 : (x.suppliedQty / x.orderedQty) * 100
        })
        setPriceNegotiation(result);
        createDataForExcel(result);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setPriceNegotiation([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setToDate(new Date());
            setFromDate(new Date());
        } else {
            setSelectedOptions([])
            setPriceNegotiation([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setToDate(new Date());
            setFromDate(new Date());
        }
    }

    useEffect(() => {
        setPage(0);
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        setPriceNegotiation([]);
    }, [formik.values.cropCategoryID, formik.values.cropID, toDate, fromDate, selectedOptions, selectedCategoryOptions, selectedProductOptions,]);

    useEffect(() => {
        setPage(0);
        setSelectedProductOptions([])
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setPage(0);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        if (priceNegotiation.length != 0) {
            calculateTotalQty()
        }
    }, [priceNegotiation]);

    useEffect(() => {
        setPage(0);
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            productSubCategoryID: selectedCategoryOptions
        })
    }, [selectedOptions, selectedCategoryOptions]);


    useEffect(() => {
        setPage(0);
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetProductSubCategoties() {
        var res = await services.GetProductSubCategotiesForDropDown()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productSubCategoryName, value: res[i].productSubCategoryID })
            }
            setProductSubcatogery(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(priceNegotiation);
        var settings = {
            sheetName: 'Category Wise Purchase Report',
            fileName: 'Category Wise Purchase Report_' + new Date(fromDate).toISOString().split('T')[0] + '-' + new Date(toDate).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Category Wise Purchase Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(
                selectedOptions.length === factory.length ? [] :
                    factory.map((option) => option.value)
            );
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(
                selectedCategoryOptions.length === productSubcatogery.length ? [] :
                    productSubcatogery.map((option) => option.value)
            );
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'SKU Category': x.productSubCategoryName,
                    'Ordered Qty': parseFloat(x.orderedQty).toFixed(2),
                    'Supplied Qty': parseFloat(x.suppliedQty).toFixed(2),
                    'Fill Rate': parseFloat(x.fillRate).toFixed(2)
                }
                res.push(vr);
            });
            var vrTotal = {
                'SKU Category': "Total:",
                'Ordered Qty': parseFloat(totalValues.totalOrderedQty).toFixed(2),
                'Supplied Qty': parseFloat(totalValues.totalSuppliedQty).toFixed(2),
                'Fill Rate':parseFloat(totalValues.totalFillRate).toFixed(2)
            }
            res.push(vrTotal);
            res.push({});
            res.push({});
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productSubcatogery.find(y => x === y.value).label
            categoryName.push(filterCategory);
        })

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.map(x => x).join(','),
            productSubCategoryID: categoryName.map(x => x).join(','),
            fromDate: new Date(fromDate).toISOString().split('T')[0],
            toDate: new Date(toDate).toISOString().split('T')[0]
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productSubcatogery.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productSubcatogery.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = productSubcatogery.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    function calculateTotalQty() {
        const totalOrderedQty = priceNegotiation.reduce((accumulator, current) => accumulator + current.orderedQty, 0);
        const totalSuppliedQty = priceNegotiation.reduce((accumulator, current) => accumulator + current.suppliedQty, 0);
        const totalFillRate = totalOrderedQty > 0 ? ((totalSuppliedQty / totalOrderedQty) * 100) : 0;
        
        
        setTotalValues({
            ...totalValues,
            totalOrderedQty: totalOrderedQty,
            totalSuppliedQty: totalSuppliedQty,
            totalFillRate:totalFillRate,

        })

    };
    return (
        <>
            <LoadingComponent />
            <Page title="Category Wise Quantity Bought against Purchase Order |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/CategoryWiseQtyBoughtAgainstPurchaseOrder"}
                        btname="Add"
                        pageName="Category Wise Quantity Bought against Purchase Order Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center *"
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth error={Boolean(touched.productSubCategoryID && errors.productSubCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Sub Category *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Sub Category *"
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedCategoryOptions.length === productSubcatogery.length} color="primary" />
                                                All Product Sub Category
                                            </MenuItem>
                                            {productSubcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productSubCategoryID && errors.productSubCategoryID && (
                                            <FormHelperText>{errors.productSubCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} align='left'>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="From *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="To *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </div>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {priceNegotiation.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                        >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                onRequestSort={handleRequestSort}
                                                                rowCount={priceNegotiation.length}
                                                            />
                                                            <TableBody>
                                                                {stableSort(priceNegotiation, getComparator(order, orderBy))
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        const labelId = `enhanced-table-checkbox-${index}`;
                                                                        return (
                                                                            <TableRow>
                                                                                <TableCell >{row.productSubCategoryName}</TableCell>
                                                                                <TableCell align='right'>{row.orderedQty == 0 ? "-" : row.orderedQty.toFixed(2)}</TableCell>
                                                                                <TableCell align='right'>{row.suppliedQty == 0 ? "-" : row.suppliedQty.toFixed(2)}</TableCell>
                                                                                <TableCell align='right'>{row.fillRate == 0 ? "-" : row.fillRate.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "bold" }} >Total</TableCell>
                                                                    <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalOrderedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalSuppliedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalFillRate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                        component="div"
                                                        count={priceNegotiation.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Category Wise Quantity Bought against Purchase Order" />}</>
                        </Form>
                    </FormikProvider>
                    {priceNegotiation.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Price Negotiation Audit Summary Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    priceNegotiation={priceNegotiation}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}